export function getLetterName(name, type) {
    if (name) {
        const nameParts = name.split(" ");
        if (name && type === 'email') {
            const email = name.split("")[0];
            return email;
        } else if (name && type === 'email-long') {
            const email = name.split("@")[0];
            const names = email.split(".");
            const firstName = names[0].charAt(0).toUpperCase() + names[0].slice(1);
            if (names[1]) {
                const lastName = names[1].charAt(0).toUpperCase() + names[1].slice(1);
                const finalName = firstName + ' ' + lastName;
                return finalName;
            } return firstName
        } else if (name && type === 'letter') {
            if (nameParts.length === 1) {
                return nameParts[0][0];
            }
            return nameParts[0][0] + nameParts[nameParts.length - 1][0];
        } else {
            if (nameParts.length === 1) {
                return nameParts[0];
            }
            return nameParts[0] + " " + nameParts[nameParts.length - 1];
        }
    }
}
